import { SET_EDITING } from "../actions/editing";

export default (state = false, { type, payload }) => {
  switch (type) {
    case SET_EDITING:
      return payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/editing.js